import React, { useEffect, useRef, useState } from "react";
import { useSearchParams, useNavigate, Link } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import { Loader2, AlertCircle } from "lucide-react";

export default function Verify() {
  const [params] = useSearchParams();
  const navigate = useNavigate();
  const { verifyMagicLink } = useAuth();
  const [error, setError] = useState("");
  const processed = useRef(false);

  useEffect(() => {
    if (processed.current) return;
    processed.current = true;
    const token = params.get("token");
    if (!token) {
      setError("No sign-in token found in the link.");
      return;
    }
    verifyMagicLink(token)
      .then(() => navigate("/", { replace: true }))
      .catch((e) => setError(e.response?.data?.detail || "Invalid or expired link."));
  }, [params, navigate, verifyMagicLink]);

  if (error) {
    return (
      <div className="grid min-h-screen place-items-center bg-mt-bg px-6">
        <div className="max-w-sm rounded-xl border border-mt-border bg-mt-card p-8 text-center shadow-sm">
          <AlertCircle className="mx-auto text-mt-text" size={32} />
          <h1 className="mt-3 font-head text-xl font-bold">Sign-in link problem</h1>
          <p className="mt-1 text-sm text-mt-mutedfg" data-testid="verify-error">{error}</p>
          <Link to="/login" data-testid="verify-back-login" className="mt-5 inline-block rounded-lg bg-mt-primary px-5 py-2.5 text-sm font-bold text-white">
            Back to sign in
          </Link>
        </div>
      </div>
    );
  }

  return (
    <div className="grid min-h-screen place-items-center bg-mt-bg">
      <div className="text-center" data-testid="verify-loading">
        <Loader2 className="mx-auto animate-spin text-mt-primary" size={32} />
        <p className="mt-3 text-sm text-mt-mutedfg">Verifying your secure link…</p>
      </div>
    </div>
  );
}
